// extracted by mini-css-extract-plugin
export var locationCard = "_er-0";